import React from 'react';
export const MOBILE_MODE = import.meta.env.VITE_MOBILE && import.meta.env.VITE_MOBILE === 'true';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
// export const API_URL = 'http://localhost:3000';
export const API_URL = MOBILE_MODE ? import.meta.env.VITE_API_URL || '' : '';
// console.log("API_URL",API_URL);

export const appEmail = "srv_dsy@acri-st.fr";
export const appAdress = <>260 Route du Pin Montard<br />06410 Biot<br />France</>;
export const appPhone = "+33 (0)4 92 967 500";

export const base_title = 'DAMPS'
export const get_page_title = (title?: string) => {
    return title ? `${base_title} | ${title}` : base_title;
}

export const PROD_URL = 'https://www.damps.info';

export const app_desciption = `The PDGS Data Archival, Management & Processing Services (DAMPS) is commissioned by the European Space Agency (ESA) \
under the Earthnet, the Long Term Data Preservation (LTDP-2) and the Mission Management Programmes following the contract 4000135398/21/I-LG`;